<template>
  <div class="nav">
    <el-menu
      :default-active="activeIndex"
      text-color="#000000"
      class="nav-content"
      mode="horizontal"
      @select="handleSelect"
      active-text-color="#053780"
    >
      <el-menu-item index="/">首页</el-menu-item>
      <el-submenu index="introduction">
        <template slot="title"
          ><span @click="clickEvent('/introduction/idea')"
            >专委会介绍</span
          ></template
        >
        <div class="sub-menu">
          <el-menu-item index="/introduction/idea">
            <svg
              t="1736753770574"
              :class="
                activeIndex == '/introduction/idea'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1484"
            >
              <path
                d="M716.032 407.0912c0-53.4016-21.36576-106.78784-60.5184-142.3872-35.58912-35.59936-85.4272-60.5184-142.38208-60.5184s-106.78784 21.36064-142.3872 60.5184c-35.59936 35.59424-60.51328 85.43232-60.51328 142.3872 0 56.95488 21.35552 106.78272 60.51328 142.38208 35.59424 35.58912 85.43232 60.51328 142.3872 60.51328 53.39136 0 106.78272-21.36064 142.38208-60.51328 39.15264-35.59936 60.5184-85.43232 60.5184-142.38208z m-199.3472 153.05728c-42.71616 0-78.3104-17.80224-106.78784-42.72128-28.48256-28.47232-46.27968-67.63008-46.27968-110.34112 0-42.71616 17.80224-78.31552 42.71616-106.78784 28.47744-28.48256 64.07168-42.71616 106.78272-42.71616 42.72128 0 78.32064 17.79712 106.78784 42.71616 28.47744 28.47744 42.72128 64.07168 42.72128 106.78784s-17.80224 78.30528-42.72128 106.78272c-24.90368 28.48256-64.06144 46.27968-103.2192 46.27968z"
                p-id="1485"
              ></path>
              <path
                d="M944.31744 771.16928l-122.5728-206.31552c26.15808-45.57312 41.84576-98.56 43.392-155.49952 2.62144-96.07168-34.19648-182.53824-92.94336-248.23808-62.50496-58.6752-146.83648-100.13696-242.91328-102.75328-96.07168-2.6112-182.53824 34.2016-244.77184 96.60416-65.69472 58.752-107.15648 143.08864-109.76768 239.1552-1.55136 56.9344 11.13088 114.2528 34.78016 161.18784L75.79136 758.2208l-22.31296 35.01056 42.60352 4.71552 149.25312 11.17696 60.47232 133.40672 20.3776 36.16256 25.96864-38.46144 129.96608-195.8912 28.4672 0.77312c10.6752 0.29184 24.9088 0.68096 35.68128-2.5856l112.29696 191.79008 23.94112 36.25472 22.41536-38.55872 71.18336-129.81248 145.98656 0.40448 46.25408 1.25952-24.02816-32.69632zM336.10752 875.69408l-50.57024-104.64256-6.72256-14.42816-14.2336-0.38912-120.8832-6.85056 96.58368-146.92864c3.36896 7.20896 44.07808 59.34592 76.15488 80.41472 0 0 69.97504 46.62784 108.9536 52.80256l-89.28256 140.02176z m175.93856-184.3968c-161.79712-4.4032-289.38752-139.136-284.98432-300.93824 4.4032-161.80224 139.13088-289.39264 300.928-284.98944 161.80224 4.4032 289.38752 139.13088 284.98432 300.928-4.39296 161.80224-139.13088 289.39776-300.928 284.99968z m250.99264 67.8144l-14.2336-0.384-7.5008 14.03904-59.84256 105.20064-81.72544-137.5488c39.43424-9.60512 75.40736-22.8608 108.01152-43.34592 32.60416-20.47488 61.84448-48.17408 87.5264-75.96032l81.61792 141.10208-113.85344-3.10272z"
                p-id="1486"
              ></path>
            </svg>
            理念宗旨
          </el-menu-item>
          <el-menu-item index="/introduction/os">
            <svg
              t="1736753963150"
              :class="
                activeIndex == '/introduction/os' ? 'icon icon-active' : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2489"
              width="200"
              height="200"
            >
              <path
                d="M882.377 667.32h-59.739V512c0-19.775-16.067-35.843-35.842-35.843h-250.9V356.681h59.737c19.776 0 35.843-16.068 35.843-35.843V153.57c0-19.775-16.067-35.843-35.843-35.843H428.367c-19.776 0-35.843 16.068-35.843 35.843v167.267c0 19.775 16.067 35.843 35.843 35.843h59.738v119.476h-250.9c-19.776 0-35.843 16.068-35.843 35.843v155.32h-59.739c-19.775 0-35.842 16.067-35.842 35.842V870.43c0 19.775 16.067 35.843 35.842 35.843H308.89c19.776 0 35.843-16.068 35.843-35.843V703.162c0-19.775-16.067-35.843-35.843-35.843h-59.738V523.948h238.953v143.371h-59.738c-19.776 0-35.843 16.068-35.843 35.843V870.43c0 19.775 16.067 35.843 35.843 35.843h167.266c19.776 0 35.843-16.068 35.843-35.843V703.162c0-19.775-16.067-35.843-35.843-35.843h-59.738V523.948h238.953v143.371H715.11c-19.776 0-35.843 16.068-35.843 35.843V870.43c0 19.775 16.067 35.843 35.843 35.843h167.267c19.775 0 35.842-16.068 35.842-35.843V703.162c0-19.775-16.067-35.843-35.842-35.843zM440.314 165.518h143.372V308.89H440.314V165.52z m-143.371 549.59v143.372H153.57V715.11h143.372z m286.743 143.372H440.314V715.11h143.372V858.48z m286.743 0H727.057V715.11H870.43V858.48z"
                fill="#333333"
                p-id="2490"
              ></path>
            </svg>
            组织架构
          </el-menu-item>
          <el-menu-item index="/introduction/rules">
            <svg
              t="1736754022287"
              :class="
                activeIndex == '/introduction/rules'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4595"
              width="200"
              height="200"
            >
              <path
                d="M852.948 69.757426s-162.345869 44.758908-309.952727 84.171312c-18.496014 0.794751-37.172652 0-55.704791 0-140.562478-37.642278-307.640725-84.171312-307.640725-84.171312-61.918295 0-112.168207 50.249912-112.168208 112.276582v589.126932c0 61.918295 52.850914 92.877443 112.168208 112.168207 0 0 151.327736 42.085656 307.640725 84.171312h56.824667c157.649615-42.085656 308.796726-84.171312 308.796726-84.171312 57.655542-14.847386 112.276582-50.249912 112.276582-112.168207V182.034008c0.036125-62.02667-50.249912-112.276582-112.240457-112.276582zM488.301983 911.326042c-153.206237-41.18253-308.616101-84.171312-308.616101-84.171311-31.862273-8.706131-56.029916-25.070768-56.029916-56.029916V182.034008c0-31.067523 25.070768-56.138291 56.029916-56.138291l308.616101 84.171312v701.259013z m420.784308-140.201227c0 30.959148-25.973894 46.420659-56.138291 56.029916 0 0-152.664362 42.519156-308.507726 83.521061V210.030904l308.507726-84.171312c31.067523 0 56.138291 25.070768 56.138291 56.138291v589.126932z"
                fill="#231815"
                p-id="4596"
              ></path>
            </svg>
            工作守则
          </el-menu-item>
          <!-- <el-menu-item index="/introduction/committee">
            <svg
              t="1736754081350"
              :class="
                activeIndex == '/introduction/committee'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8200"
              width="200"
              height="200"
            >
              <path
                d="M902.8 691.8C882 639 851.3 590.6 812.4 549.1c-39-41.4-84.4-73.9-135-96.6-14.6-6.6-29.5-12.2-44.6-17 39.2-34 64-84.2 64-140 0-102.2-83.2-185.4-185.4-185.4S326 193.3 326 295.5c0 55.9 24.8 106 64 140.1-15.1 4.7-29.9 10.4-44.5 16.9-50.9 23-96.8 55.8-135 96.6-38.9 41.4-69.7 89.8-90.6 142.7C98 747.2 86.7 806.4 86.8 866c0 17.7 14.3 32 32 32s32-14.3 32-32c0-212.4 161.8-385.1 360.6-385.1S872 653.7 872 866c0 17.7 14.3 32 32 32s32-14.3 32-32c0.1-59.6-11.1-118.8-33.2-174.2zM511.4 174.1c67 0.1 121.3 54.4 121.4 121.4 0 67-54.4 121.4-121.4 121.4S390 362.6 390 295.5c0-67 54.4-121.4 121.4-121.4z"
                p-id="8201"
              ></path>
              <path
                d="M529 622.9c-0.2-1.2 0-2.4 0.5-3.5l15.2-32.3c0.4-0.8 0.6-1.7 0.6-2.6 0-3.3-2.7-6-6-6h-55.7c-0.9 0-1.8 0.2-2.6 0.6-3 1.4-4.3 5-2.9 8l15.2 32.3c0.5 1.1 0.7 2.3 0.5 3.5l-29.1 175.5c-0.4 2.1 0.4 4.2 2 5.6l40.8 34.5c2.2 1.9 5.5 1.9 7.8 0l40.8-34.5c1.6-1.4 2.4-3.5 2.1-5.6L529 622.9z"
                p-id="8202"
              ></path>
            </svg>
            委员会
          </el-menu-item> -->
        </div>
      </el-submenu>
      <el-submenu index="newList">
        <template slot="title">
          <span @click="clickEvent('/news/list')">新闻动态</span>
        </template>
        <div class="sub-menu">
          <el-menu-item index="/news/list">
            <svg
              t="1736919651541"
              :class="activeIndex == '/news/list' ? 'icon icon-active' : 'icon'"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13830"
              width="200"
              height="200"
            >
              <path
                d="M895.957333 1023.914667H128.042667a127.957333 127.957333 0 0 1-127.978667-127.957334V256.042667a96 96 0 0 1 96-96h31.978667V96.064a96 96 0 0 1 96-96h703.893333a96 96 0 0 1 96 96v799.893333a127.957333 127.957333 0 0 1-127.978667 127.957334z m63.978667-927.850667c0-17.664-14.357333-32-32-32H224.042667a32 32 0 0 0-32 32v767.893333a32 32 0 0 1-64 0V224.042667H96.064a32 32 0 0 0-32 32v639.914666a64.064 64.064 0 0 0 63.978667 63.978667h767.914666a64.106667 64.106667 0 0 0 63.978667-63.978667V96.064z m-79.978667 800H623.978667a16 16 0 1 1 0-31.978667h255.978666a16 16 0 1 1 0 31.978667z m0-95.978667H623.978667a16 16 0 0 1 0-32h255.978666a16 16 0 0 1 0 32z m0-96H623.978667a16 16 0 1 1 0-31.978666h255.978666a16 16 0 0 1 0 31.978666z m0-95.978666H272.042667a15.978667 15.978667 0 1 1 0-31.978667h607.914666a16 16 0 1 1 0 31.978667z m0-95.978667H272.042667a16 16 0 1 1 0-32h607.914666a16 16 0 0 1 0 32z m-0.064-95.957333H623.914667a16 16 0 0 1 0-32h255.978666a16 16 0 0 1 0 32z m0-95.978667H623.914667a16 16 0 0 1 0-32h255.978666a16 16 0 0 1 0 32z m0-96H623.914667a16 16 0 1 1 0-32h255.978666a16 16 0 0 1 0 32zM512 416.021333H288.021333a32 32 0 0 1-31.978666-32V160.170667c0-17.664 14.314667-31.978667 31.978666-31.978667H512a32 32 0 0 1 32 31.978667v223.850666a32 32 0 0 1-32 32zM480 192.042667h-159.978667v159.978666H480V192.042667z m-207.957333 480.064H528a16 16 0 0 1 0 31.978666H272.042667a15.978667 15.978667 0 1 1 0-31.978666z m0 95.978666H528a16 16 0 0 1 0 32H272.042667a16 16 0 1 1 0-32z m0 96H528a16 16 0 1 1 0 31.978667H272.042667a15.978667 15.978667 0 1 1 0-31.978667z"
                fill="#2c2c2c"
                p-id="13831"
              ></path>
            </svg>
            专委新闻
          </el-menu-item>
          <el-menu-item index="/news/notice">
            <svg
              t="1736754674148"
              :class="
                activeIndex == '/news/notice' ? 'icon icon-active' : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="48743"
              width="200"
              height="200"
            >
              <path
                d="M260.7 781.5h456.9v-45.3H260.7v45.3z m0-90.7h319.8v-45.3H260.7v45.3z m-45.7 136h594v-589H215v589z m594 45.3H215c-25.2 0-45.7-20.4-45.7-45.6V192.7c0-25.2 20.5-45.6 45.7-45.6h594c25.2 0 45.7 20.4 45.7 45.6v633.8c0 25.1-20.5 45.6-45.7 45.6z"
                p-id="48744"
              ></path>
              <path
                d="M260.7 600.2V283.1h502.6v317.1H260.7z m270.7-98c0.2-0.1 0.7-0.7 1.5-1.5l4.1-4.1c31.5-31.2 94.5-93.7 94.5-93.7v38.9c0 12.6 10.2 22.8 22.8 22.8s22.8-10.2 22.8-22.8v-90.5c0-3-0.6-5.8-1.7-8.4-0.9-2.2-2.2-4-3.7-5.7-0.3-0.4-0.4-0.8-0.7-1.1-0.5-0.7-0.3-1.6-0.9-2.3-1.3-1.3-3.2-1-4.7-1.9-1.6-0.9-3.2-1.5-4.9-2-2.1-0.5-4.1-1.2-6.2-1.2-0.4 0-0.7 0.2-1.1 0.2-0.6 0-1-0.3-1.6-0.2h-88.7c-12.6 0-22.8 10.1-22.8 22.7 0 12.5 12.3 21.2 45.7 22.6h12.8s-52.1 51.6-84.2 83.5c-25.9-26.2-74.8-75.8-75.4-76.4-4.6-4.5-10.5-6.3-16.5-6-5.9-0.3-11.9 1.5-16.4 6-0.9 0.9-91.1 92.2-91.1 92.2-8.5 8.5-8.5 22.3 0 30.8 8.6 8.5 22.5 8.5 31 0l76.6-75.9 76.6 75.9c8.5 8.5 23.5 6.8 32-1.6 0-0.1 0.1-0.2 0.2-0.3z"
                p-id="48745"
              ></path>
            </svg>
            行业动态
          </el-menu-item>
          <el-menu-item index="/news/policyNews">
            <svg
              t="1736754714287"
              :class="
                activeIndex == '/news/policyNews' ? 'icon icon-active' : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="50057"
              width="200"
              height="200"
            >
              <path
                d="M91.192847 75.820733 91.192847 75.820733C99.718898 78.263838 115.132045 66.729526 115.132045 57.588826L115.132045 665.956755C115.132045 676.896818 128.407147 697.184838 138.5387 701.539572L530.085632 869.833794C529.062384 869.393979 526.178321 868.931432 521.763798 869.516833L531.691921 868.200267 541.620045 869.516833C537.205522 868.931432 534.321459 869.393979 533.298211 869.833794L924.845138 701.539572C934.976695 697.184838 948.251799 676.896818 948.251799 665.956755L948.251799 57.588826C948.251799 66.729526 963.664945 78.263838 972.190996 75.820733L552.498796 196.081791 531.691921 202.043915 510.885047 196.081791 91.192847 75.820733 91.192847 75.820733ZM111.99972 2.784728 111.99972 2.784728 531.691921 123.045785 951.384122 2.784728C990.825626-8.517073 1023.989957 15.831129 1023.989957 57.588826L1023.989957 665.956755C1023.989957 706.95413 992.95877 754.903545 954.679864 771.356531L563.132933 939.650757C551.880355 944.487322 541.175307 946.077598 531.691921 944.819997 522.208536 946.077598 511.503488 944.487322 500.25091 939.650757L108.703977 771.356531C70.425071 754.903545 39.393886 706.95413 39.393886 665.956755L39.393886 57.588826C39.393886 15.831129 72.558213-8.517073 111.99972 2.784728L111.99972 2.784728 111.99972 2.784728ZM304.477443 513.689976 215.441898 560.63497 232.446173 461.203881 160.414904 390.786392 259.95967 376.279592 304.477443 285.814199 348.995216 376.279592 448.539983 390.786392 376.508713 461.203881 393.512989 560.63497 304.477443 513.689976 304.477443 513.689976 304.477443 513.689976ZM657.385826 398.200043 883.558047 321.807086C903.378679 315.112379 914.0351 293.57068 907.359819 273.692358 900.684537 253.814035 879.205353 243.126604 859.384725 249.821311L633.2125 326.214269C613.39186 332.908977 602.735447 354.450675 609.410725 374.328997 616.086003 394.207321 637.565186 404.894753 657.385826 398.200043L657.385826 398.200043 657.385826 398.200043ZM657.385826 550.117231 883.558047 473.724273C903.378679 467.029563 914.0351 445.487865 907.359819 425.609544 900.684537 405.731219 879.205353 395.043791 859.384725 401.738497L633.2125 478.131455C613.39186 484.826165 602.735447 506.367862 609.410725 526.246184 616.086003 546.124505 637.565186 556.811937 657.385826 550.117231L657.385826 550.117231 657.385826 550.117231ZM657.385826 702.03441 883.558047 625.641456C903.378679 618.946747 914.0351 597.405049 907.359819 577.526731 900.684537 557.648406 879.205353 546.960974 859.384725 553.65568L633.2125 630.048642C613.39186 636.743344 602.735447 658.285042 609.410725 678.163367 616.086003 698.041692 637.565186 708.72912 657.385826 702.03441L657.385826 702.03441 657.385826 702.03441Z"
                fill="#000000"
                p-id="50058"
              ></path>
            </svg>
            政策新闻
          </el-menu-item>
        </div>
      </el-submenu>
      <!-- <el-menu-item index="activityList">活动与会议</el-menu-item>
            <el-menu-item index="standard">标准与测评</el-menu-item> -->
      <el-menu-item index="/expert/list">专家风采</el-menu-item>
      <!-- <el-submenu index="expert">
        <template slot="title">
          <span @click="clickEvent('/expert/list')">认证专家</span>
        </template>
        <div class="sub-menu" style="display: none;">
          <el-menu-item index="/expert/list">
            <svg :class="activeIndex == '/expert/list' ? 'icon icon-active' : 'icon'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="61" height="62" viewBox="0 0 61 62"><defs><clipPath id="master_svg0_2_522"><rect x="0" y="0" width="200" height="200" rx="0"/></clipPath></defs><g clip-path="url(#master_svg0_2_522)"><g><path d="M11.87420246875,30.1374170390625L11.87420246875,41.1114160390625L30.75977946875,51.5274240390625L49.64535546875,41.1114160390625L49.64535546875,30.1498280390625L30.75977946875,40.5658260390625L11.87420246875,30.1374170390625ZM30.75977946875,2.1754150390625L1.08935546875,18.6302390390625L30.75977946875,35.0725940390625L55.03778846875,21.6434150390625L55.03778846875,40.5658260390625L60.43020646875,40.5658260390625L60.43020646875,18.6302390390625L30.75977946875,2.1754150390625Z" fill="#272636" fill-opacity="1" style="mix-blend-mode:passthrough"/></g></g></svg>
            认证专家
          </el-menu-item>
        </div>
      </el-submenu> -->
      <el-submenu index="kb">
        <template slot="title">
          <span @click="clickEvent('/kb/doc')">技术专区</span>
        </template>
        <div class="sub-menu">
          <el-menu-item index="/kb/doc">
            <svg
              t="1736754197754"
              :class="activeIndex == '/kb/doc' ? 'icon icon-active' : 'icon'"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="15238"
              width="200"
              height="200"
            >
              <path
                d="M57.664 748.136c-5.944-3.295-10.247-8.714-12.119-15.244-1.868-6.539-1.08-13.411 2.219-19.359 4.478-8.072 13.01-13.092 22.263-13.092 4.294 0 8.555 1.102 12.323 3.183l402.873 223.504 436.302-142.411c17.559-36.286 22.05-72.295 13.345-107.086-4.697-18.75-12.338-32.662-16.823-39.741l-440.096 150.394-420.376-235.507c-12.241-6.862-16.619-22.402-9.764-34.636 4.491-8.025 13.003-13.012 22.211-13.012 4.333 0 8.632 1.125 12.427 3.253l400.551 224.39 438.695-149.911c19.12-31.678 22.214-65.517 9.192-100.631-6.67-17.955-16.275-32.407-22.561-40.75l-430.123 154.808-420.679-234.597c-5.934-3.309-10.228-8.733-12.082-15.269-1.858-6.541-1.057-13.411 2.257-19.347 4.481-8.048 13.003-13.055 22.233-13.055 4.314 0 8.597 1.116 12.377 3.225l400.449 223.319 430.457-154.933c23.625-38.022 29.752-75.159 18.202-110.416-3.731-11.367-8.822-20.847-13.345-27.897l-439.723 166.922-446.347-243.102 491.647-124.978 413.601 145.031 3.97 3.788c2.611 2.498 25.8 25.45 38.564 64.388 11.728 35.796 16.481 91.955-26.264 157.711 7.805 11.144 17.334 27.002 24.614 46.205 19.617 51.773 14.259 103.514-15.431 150.023 6.356 10.462 15.244 27.75 21.089 50.203 9.108 34.988 12.689 90.15-22.027 154.275l-4.842 8.916-476.985 155.705-422.272-234.264zM482.151 358.348l373.591-141.813-84.886-29.761-371.629 126.41 82.924 45.164z"
                fill="#272636"
                p-id="15239"
              ></path>
            </svg>
            知识专区
          </el-menu-item>
          <el-menu-item index="/kb/term">
            <svg
              t="1736754246638"
              :class="activeIndex == '/kb/term' ? 'icon icon-active' : 'icon'"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="17296"
              width="200"
              height="200"
            >
              <path
                d="M904 176v112H120V176h784m0-56H120c-30.9 0-56 25.1-56 56v112c0 30.9 25.1 56 56 56h784c30.9 0 56-25.1 56-56V176c0-30.9-25.1-56-56-56z"
                fill="#231815"
                p-id="17297"
              ></path>
              <path
                d="M820 232m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17298"
              ></path>
              <path
                d="M708 232m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17299"
              ></path>
              <path
                d="M904 456v112H120V456h784m0-56H120c-30.9 0-56 25.1-56 56v112c0 30.9 25.1 56 56 56h784c30.9 0 56-25.1 56-56V456c0-30.9-25.1-56-56-56z"
                fill="#231815"
                p-id="17300"
              ></path>
              <path
                d="M820 512m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17301"
              ></path>
              <path
                d="M596 232m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17302"
              ></path>
              <path
                d="M596 792m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17303"
              ></path>
              <path
                d="M708 512m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17304"
              ></path>
              <path
                d="M904 736v112H120V736h784m0-56H120c-30.9 0-56 25.1-56 56v112c0 30.9 25.1 56 56 56h784c30.9 0 56-25.1 56-56V736c0-30.9-25.1-56-56-56z"
                fill="#231815"
                p-id="17305"
              ></path>
              <path
                d="M820 792m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17306"
              ></path>
              <path
                d="M708 792m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z"
                fill="#231815"
                p-id="17307"
              ></path>
            </svg>
            资料库
          </el-menu-item>
          <el-menu-item index="/kb/codePractice">
            <svg
              t="1736754714287"
              :class="
                activeIndex == '/kb/codePractice' ? 'icon icon-active' : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="50057"
              width="200"
              height="200"
            >
              <path
                d="M91.192847 75.820733 91.192847 75.820733C99.718898 78.263838 115.132045 66.729526 115.132045 57.588826L115.132045 665.956755C115.132045 676.896818 128.407147 697.184838 138.5387 701.539572L530.085632 869.833794C529.062384 869.393979 526.178321 868.931432 521.763798 869.516833L531.691921 868.200267 541.620045 869.516833C537.205522 868.931432 534.321459 869.393979 533.298211 869.833794L924.845138 701.539572C934.976695 697.184838 948.251799 676.896818 948.251799 665.956755L948.251799 57.588826C948.251799 66.729526 963.664945 78.263838 972.190996 75.820733L552.498796 196.081791 531.691921 202.043915 510.885047 196.081791 91.192847 75.820733 91.192847 75.820733ZM111.99972 2.784728 111.99972 2.784728 531.691921 123.045785 951.384122 2.784728C990.825626-8.517073 1023.989957 15.831129 1023.989957 57.588826L1023.989957 665.956755C1023.989957 706.95413 992.95877 754.903545 954.679864 771.356531L563.132933 939.650757C551.880355 944.487322 541.175307 946.077598 531.691921 944.819997 522.208536 946.077598 511.503488 944.487322 500.25091 939.650757L108.703977 771.356531C70.425071 754.903545 39.393886 706.95413 39.393886 665.956755L39.393886 57.588826C39.393886 15.831129 72.558213-8.517073 111.99972 2.784728L111.99972 2.784728 111.99972 2.784728ZM304.477443 513.689976 215.441898 560.63497 232.446173 461.203881 160.414904 390.786392 259.95967 376.279592 304.477443 285.814199 348.995216 376.279592 448.539983 390.786392 376.508713 461.203881 393.512989 560.63497 304.477443 513.689976 304.477443 513.689976 304.477443 513.689976ZM657.385826 398.200043 883.558047 321.807086C903.378679 315.112379 914.0351 293.57068 907.359819 273.692358 900.684537 253.814035 879.205353 243.126604 859.384725 249.821311L633.2125 326.214269C613.39186 332.908977 602.735447 354.450675 609.410725 374.328997 616.086003 394.207321 637.565186 404.894753 657.385826 398.200043L657.385826 398.200043 657.385826 398.200043ZM657.385826 550.117231 883.558047 473.724273C903.378679 467.029563 914.0351 445.487865 907.359819 425.609544 900.684537 405.731219 879.205353 395.043791 859.384725 401.738497L633.2125 478.131455C613.39186 484.826165 602.735447 506.367862 609.410725 526.246184 616.086003 546.124505 637.565186 556.811937 657.385826 550.117231L657.385826 550.117231 657.385826 550.117231ZM657.385826 702.03441 883.558047 625.641456C903.378679 618.946747 914.0351 597.405049 907.359819 577.526731 900.684537 557.648406 879.205353 546.960974 859.384725 553.65568L633.2125 630.048642C613.39186 636.743344 602.735447 658.285042 609.410725 678.163367 616.086003 698.041692 637.565186 708.72912 657.385826 702.03441L657.385826 702.03441 657.385826 702.03441Z"
                fill="#231815"
                p-id="50058"
              ></path>
            </svg>
            数存百科
          </el-menu-item>
        </div>
      </el-submenu>
      <el-submenu index="centigradeIndex">
        <template slot="title">
          <span @click="clickEvent('/centigrade/dynamic')">成员服务</span>
        </template>
        <div class="sub-menu">
          <!-- <el-menu-item index="/centigrade/display">
            <svg
              t="1736754802954"
              :class="
                activeIndex == '/centigrade/display'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="51114"
              width="200"
              height="200"
            >
              <path
                d="M752.48 546.8a273.92 273.92 0 0 1 44.46 19.32q81.09 45 118.59 129.25c17.28 39 23.79 80 21.54 122.41-0.75 13.45-7.62 22.73-18.9 25.35-16.46 3.84-31.21-9-30-26.17 3.19-47.26-7.24-91.36-32.77-131.37-34.05-53.38-82.47-86.82-145.05-99.81-9.68-2-19.52-2.69-29.23-4.2-11-1.73-19.55-10.66-20.37-21.08-0.94-11.85 5.52-21.94 16.6-25.5 29-9.36 52.37-26.65 71.31-50 19.87-24.52 31.41-52.65 33.81-84 3.38-44.33-9.42-83.78-39.22-117.38-22.75-25.7-51.21-41.94-84.77-49.5-14-3.15-28.25-3.72-42.55-3.74A23.41 23.41 0 0 1 592.65 212c-3.12-14.43 7.41-27.15 23.33-27.79 30.44-1.19 59.92 3.56 87.79 15.8 63.09 27.63 104.66 74.38 120.3 141 16.55 70.24-1.38 132.65-50.39 186.09-3.17 3.48-6.63 6.64-10.06 9.81s-7 6.22-11.14 9.84z m-334.56 79.54l33.92 57.22c15.4 25.87 30.71 51.77 46.2 77.6 1.53 2.56 1.48 4-0.77 6.16q-38.37 37.2-76.45 74.68c-2.22 2.17-3.44 2.53-5.86 0.09q-38.29-37.54-76.75-74.95c-1.8-1.75-2.38-2.94-0.92-5.41q39.52-66.27 78.84-132.62c0.41-0.76 0.92-1.42 1.79-2.74zM741 819.5c-3.29-19.75-8-39.12-15-57.86q-49.5-131.22-178-189.77-13.17-5.88-26.88-10.52c55.72-35.28 90.45-84.14 99.72-149s-8.93-122-53.55-170.1a209.49 209.49 0 0 0-308.38 1.07c-42.43 46.33-60.36 101.57-52.86 163.69 8.11 67.06 43.25 117.68 100.24 154-1 1.27-2.57 1.42-3.86 1.85-8.49 2.94-16.76 6.28-24.9 10q-96.18 43.77-150 134A321.35 321.35 0 0 0 87 818.31c-2.1 12.29 2.74 23.07 13.18 27.79 12.4 5.51 25 2.54 33-7.33 4.16-5.16 5.24-11.34 6.43-17.44 11.49-58.56 38.28-109.22 82.55-149.66 73.73-67.39 160.58-90.5 258.07-67.85C559 622.09 617.91 668.51 658 738.14c16.32 28.24 26 58.86 31.91 90.67 2.52 13.43 16.33 22 30.49 19.42 13.31-2.36 22.8-15.53 20.57-28.73zM414 542.85A162 162 0 0 1 299.52 496a159 159 0 0 1-47.1-113.43c0.27-88.64 72.72-160.11 161.57-159.89 89 0.19 161.43 72 161.38 160.13S503 543.08 414 542.85z m0 0"
                fill="#000000"
                p-id="51115"
              ></path>
            </svg>
            成员介绍
          </el-menu-item> -->
          <el-menu-item index="/centigrade/dynamic">
            <svg 
              t="1773190307543" 
              :class="
                activeIndex == '/centigrade/dynamic'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1024 1024" 
              version="1.1" 
              xmlns="http://www.w3.org/2000/svg" 
              p-id="10020" 
              width="200" 
              height="200">
              <path d="M453.12 302.08c0-7.68-5.12-12.8-12.8-12.8H192c-7.68 0-12.8 5.12-12.8 12.8v140.8c0 7.68 5.12 12.8 12.8 12.8h248.32c7.68 0 12.8-5.12 12.8-12.8v-140.8zM186.88 701.44c0 5.12 5.12 7.68 7.68 7.68h506.88c5.12 0 7.68-5.12 7.68-7.68v-17.92c0-5.12-5.12-7.68-7.68-7.68H197.12c-5.12 0-7.68 5.12-7.68 7.68v17.92zM186.88 573.44c0 5.12 5.12 7.68 7.68 7.68h506.88c5.12 0 7.68-5.12 7.68-7.68v-17.92c0-5.12-5.12-7.68-7.68-7.68H197.12c-5.12 0-7.68 5.12-7.68 7.68v17.92zM532.48 317.44c0 5.12 5.12 7.68 7.68 7.68h161.28c5.12 0 7.68-5.12 7.68-7.68v-17.92c0-5.12-5.12-7.68-7.68-7.68h-161.28c-5.12 0-7.68 5.12-7.68 7.68v17.92zM532.48 445.44c0 5.12 5.12 7.68 7.68 7.68h161.28c5.12 0 7.68-5.12 7.68-7.68v-17.92c0-5.12-5.12-7.68-7.68-7.68h-161.28c-5.12 0-7.68 5.12-7.68 7.68v17.92z" fill="#040000" p-id="10021"></path><path d="M926.72 299.52c-7.68-10.24-20.48-15.36-33.28-15.36h-28.16s-10.24 0-10.24 7.68v20.48c0 7.68 10.24 7.68 10.24 7.68h28.16c2.56 0 5.12 0 5.12 2.56s2.56 2.56 0 5.12c0 0-61.44 227.84-81.92 304.64h-2.56V202.24c0-25.6-23.04-48.64-48.64-48.64h-640C99.84 153.6 76.8 176.64 76.8 202.24v588.8c0 25.6 23.04 48.64 48.64 48.64H768c15.36 0 30.72-7.68 38.4-20.48 5.12-5.12 10.24-12.8 12.8-23.04l115.2-460.8c2.56-12.8 0-25.6-7.68-35.84z m-145.92 491.52c0 7.68-5.12 12.8-12.8 12.8H125.44c-7.68 0-12.8-5.12-12.8-12.8v-588.8c0-7.68 5.12-12.8 12.8-12.8H768c7.68 0 12.8 5.12 12.8 12.8v588.8z" fill="#040000" p-id="10022"></path>
            </svg>
            成员动态
          </el-menu-item>
          <el-menu-item index="/centigrade/introduce">
            <svg
              t="1736754857911"
              :class="
                activeIndex == '/centigrade/introduce'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="53131"
              width="200"
              height="200"
            >
              <path
                d="M511.5904 909.2096c-22.9888 0-45.1072-9.6768-60.7232-26.624L79.9744 479.5392c-26.0608-28.3136-28.928-71.7312-6.8608-103.2192l157.6448-224.8704c15.4112-22.016 40.704-35.1232 67.5328-35.1232h434.3808a82.432 82.432 0 0 1 68.096 35.9424l148.48 217.344a82.2528 82.2528 0 0 1-6.8096 101.7344l-369.5616 410.5728a82.65216 82.65216 0 0 1-60.8768 27.2896h-0.4096zM298.2912 167.5264c-10.1888 0-19.7632 4.9664-25.6 13.312L115.0464 405.7088c-8.3968 11.9296-7.2704 28.416 2.6112 39.168l370.944 402.9952a31.0016 31.0016 0 0 0 23.04 10.0864h0.2048c8.9088-0.0512 17.1008-3.7376 23.0912-10.3424l369.5616-410.5728c9.6768-10.752 10.752-26.624 2.56-38.6048l-148.48-217.344a31.26784 31.26784 0 0 0-25.856-13.6192H298.2912z"
                fill="#000000"
                p-id="53132"
              ></path>
              <path
                d="M512 719.5648c-7.2192 0-14.08-3.0208-18.8928-8.3456L350.0544 554.496a25.57952 25.57952 0 0 1 1.6384-36.1472 25.57952 25.57952 0 0 1 36.1472 1.6384L512 656.0256l124.2112-136.0384a25.58464 25.58464 0 1 1 37.7856 34.5088l-143.1552 156.7232a25.40544 25.40544 0 0 1-18.8416 8.3456z"
                fill="#000000"
                p-id="53133"
              ></path>
            </svg>
            成员权益
          </el-menu-item>
          <el-menu-item index="/centigrade/rights">
            <svg
              t="1736754888653"
              :class="
                activeIndex == '/centigrade/rights'
                  ? 'icon icon-active'
                  : 'icon'
              "
              viewBox="0 0 1031 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="54172"
              width="200"
              height="200"
            >
              <path
                d="M451.072 61.952c-117.76-1.536-220.672 98.816-222.72 223.232-1.024 70.144 29.696 134.144 83.456 179.2l15.872 9.728-16.384 6.144c-146.944 55.296-247.296 194.048-249.344 353.28v2.56c0 58.88 48.128 107.008 107.008 107.008l289.792 3.584c9.728 0 25.6-3.584 26.112-22.528 0.512-22.528-15.872-25.088-25.088-25.088l-289.792-3.584c-27.648 0-59.904-31.744-59.904-59.904v-1.536c2.048-168.448 138.752-313.856 300.032-320.512l44.544 0.512c37.888-2.56 92.16-11.776 121.344-36.352l12.8-9.728c54.784-43.52 87.04-107.008 88.064-177.152 2.048-123.904-98.304-227.328-225.792-228.864z m1.536 403.456c-97.28-1.024-176.64-82.944-175.104-179.712 1.024-97.28 82.944-176.128 179.712-175.104 97.28 1.024 176.64 82.944 175.104 179.712-1.536 97.28-82.432 176.64-179.712 175.104z"
                fill=""
                p-id="54173"
              ></path>
              <path
                d="M526.848 697.856h391.68c14.336 0 26.112 12.288 26.112 26.112s-12.288 26.112-26.112 26.112h-391.68c-14.336 0-26.112-12.288-26.112-26.112 0-14.848 11.776-26.112 26.112-26.112z"
                fill=""
                p-id="54174"
              ></path>
              <path
                d="M749.056 530.432V922.112c0 14.336-12.288 26.112-26.112 26.112s-26.112-12.288-26.112-26.112v-391.68c0-14.336 12.288-26.112 26.112-26.112 13.824-0.512 26.112 11.776 26.112 26.112z"
                fill=""
                p-id="54175"
              ></path>
            </svg>
            申请加入
          </el-menu-item>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "Nav",
  data() {
    return {
      activeIndex: "/",
    };
  },
  methods: {
    clickEvent(key) {
      if (key == '/introduction/idea') {
        this.$store.commit('SET_NAV_TITLE', '理念宗旨')
      } else if (key == '/news/list') {
        this.$store.commit('SET_NAV_TITLE', '专委新闻')
      } else if (key == '/kb/doc') {
        this.$store.commit('SET_NAV_TITLE', '知识专区')
      } else if (key == '/centigrade/dynamic') {
        this.$store.commit('SET_NAV_TITLE', '成员动态')
      } else if (key == '/expert/list') {
        this.$store.commit('SET_NAV_TITLE', '专家风采')
        // 从顶部导航进入专家页面，默认展示当前年度
        this.$router.push({ path: '/expert/' + new Date().getFullYear() })
        return
      }
      this.$router.push({ path: key });
    },
    handleSelect(key) {
      if (this.activeIndex === key && key !== '/expert/list') return;
      if (this.activeIndex == "/" && key == "/") return;
      if (key) {
        if (key == "home") {
          this.$router.push({ name: "home" });
        } else {
          switch (key) {
            case '/introduction/idea':
              this.$store.commit('SET_NAV_TITLE', '理念宗旨')
              break;
            case '/introduction/os':
              this.$store.commit('SET_NAV_TITLE', '组织架构')
              break;
            case '/introduction/rules':
              this.$store.commit('SET_NAV_TITLE', '工作守则')
              break;
            case '/introduction/committee':
              this.$store.commit('SET_NAV_TITLE', '委员会')
              break;
            case '/news/list':
              this.$store.commit('SET_NAV_TITLE', '专委新闻')
              break;
            case '/news/notice':
              this.$store.commit('SET_NAV_TITLE', '行业动态')
              break;
            case '/news/policyNews':
              this.$store.commit('SET_NAV_TITLE', '政策新闻')
              break;
            case '/kb/doc':
              this.$store.commit('SET_NAV_TITLE', '知识专区')
              break;
            case '/kb/term':
              this.$store.commit('SET_NAV_TITLE', '资料库')
              break;
            case '/centigrade/dynamic':
              this.$store.commit('SET_NAV_TITLE', '成员动态')
              break;
            case '/centigrade/introduce':
              this.$store.commit('SET_NAV_TITLE', '成员权益')
              break;
            case '/centigrade/rights':
              this.$store.commit('SET_NAV_TITLE', '申请加入')
              break;
            case '/expert/list':
              this.$store.commit('SET_NAV_TITLE', '专家风采')
              // 从顶部导航选择专家风采，默认展示当前年度
              this.$router.push({ path: '/expert/' + new Date().getFullYear() })
              return;
            default:
              break;
          }
          this.$router.push({ path: key });
        }
      }
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.activeIndex = val.path;
        // 专家相关路由都高亮顶部“专家风采”
        if (val.path.indexOf('/expert/') === 0) {
          this.activeIndex = '/expert/list'
          this.$store.commit('SET_NAV_TITLE', '专家风采')
        }
      },
    },
  },
  mounted() {
    // if (this.$route.name) {
    //   this.activeIndex = this.$route.name;
    // }
  },
};
</script>
<style lang="less" scoped>
.nav {
  width: 100%;
  height: 100%;

  .nav-content {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  .el-menu.el-menu--horizontal {
    border: none;

    .el-menu-item,
    :deep(.el-submenu__title) {
      font-size: 18px;
      // width: 182px;
      height: 54px;
      font-weight: 600;
      padding: 0 5px;
      margin-right: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.is-active {
        font-weight: 700;
        color: #053780;
        border-bottom-color: #f17b20 !important;
        // border-bottom:none;
        // background-image: url(../assets/images/nav_active.png);
        background-repeat: no-repeat;
        background-size: 25%;
        background-position: 90px center;

        &:nth-child(2),
        &:nth-child(4),
        &:nth-child(5) {
          background-position: 115px center;
        }

        &:nth-child(3),
        &:nth-child(7) {
          background-position: 106px center;
        }

        &:nth-child(6) {
          background-position: 98px center;
        }
      }
    }

    .el-menu-item:first-child {
      margin-left: 30px;
    }
  }
}

:deep(.el-menu--horizontal > .el-submenu.is-active .el-submenu__title) {
  border-bottom-color: #f17b20 !important;
  color: #053780;
}

:deep(.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow) {
  display: none;
}
.sub-menu {
  display: flex;
  padding: 29px 26px 25px 30px;
  box-sizing: border-box;
  .el-menu-item {
    padding: 0 !important;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    display: flex;
    align-items: center;
    .icon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .icon-active path {
      fill: #053780; //修改svg图片颜色
    }
    &::after {
      content: "|";
      height: 30px;
      margin: 20px;
      color: #d9d9d9;
    }
  }
  .el-menu-item:last-child {
    &::after {
      content: "";
    }
  }
}
.el-menu--popup-bottom-start {
  margin-top: 0;
}
</style>
